'use strict';
import { db } from './firebase'

import {
    query,
    getDocs,
    collection,
    where,
    addDoc,
    updateDoc,
    doc,
} from "firebase/firestore";
import { RepositoryTypes } from '../interfaces/RepositoryTypes';

const getRepositories = async (user_uuid: string) => {

    const q = query(
        collection(db, `repositories`),
        where("user_uuid", "==", user_uuid)
    );

    const data: any = [];

    const querySnapshot = await getDocs(q);

    if (querySnapshot) {
        querySnapshot.forEach((doc) => {
            data.push(doc.data());
        });
    }

    return data
};

const saveRepository = async (repository: RepositoryTypes) => {
    await addDoc(collection(db, "repositories"), repository);
};

export {
    getRepositories,
    saveRepository,
};
